export const ADD_TOAST = "ADD_TOAST";
export const ADD_TOAST_SUCCESS = "ADD_TOAST_SUCCESS";
export const REMOVE_TOAST = "REMOVE_TOAST";
